import { useParams } from "react-router";

interface UseReportModeResult {
  mode: "view" | "edit" | "template";
}
const builderPrefix = "edit";
const runPrefix = "view";

const useReportMode = (): UseReportModeResult => {
  const starParam = useParams()["*"] || "";

  if (starParam.includes("template")) {
    return { mode: "template" };
  }

  if (starParam.endsWith(builderPrefix)) {
    return { mode: "edit" };
  }

  if (starParam.endsWith(runPrefix)) {
    return { mode: "view" };
  }

  return { mode: "view" };
};

export default useReportMode;
